// Module
var code = "<template> <require from=\"./tag.scss\"></require> <slot></slot> <div if.bind=\"remove || tagsInput\" class=\"tag-remove\"> <icon name=\"md-clear\" click.trigger=\"onRemoveMouseDown()\"></icon> </div> </template> ";
// Exports
module.exports = code;